webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BarExample__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LineExample__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DoughnutExample__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PieExample__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RadarExample__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PolarAreaExample__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BubbleExample__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ReactiveExample__ = __webpack_require__(11);











/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    BarExample: __WEBPACK_IMPORTED_MODULE_0__components_BarExample__["a" /* default */],
    LineExample: __WEBPACK_IMPORTED_MODULE_1__components_LineExample__["a" /* default */],
    DoughnutExample: __WEBPACK_IMPORTED_MODULE_2__components_DoughnutExample__["a" /* default */],
    PieExample: __WEBPACK_IMPORTED_MODULE_3__components_PieExample__["a" /* default */],
    RadarExample: __WEBPACK_IMPORTED_MODULE_4__components_RadarExample__["a" /* default */],
    PolarAreaExample: __WEBPACK_IMPORTED_MODULE_5__components_PolarAreaExample__["a" /* default */],
    BubbleExample: __WEBPACK_IMPORTED_MODULE_6__components_BubbleExample__["a" /* default */],
    ReactiveExample: __WEBPACK_IMPORTED_MODULE_7__components_ReactiveExample__["a" /* default */]
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  data: function data() {
    return {
      gradient: null
    };
  },
  mounted: function mounted() {
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
    this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)');
    this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
    this.gradient.addColorStop(1, 'rgba(145, 67, 204, 0.46)');

    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [{
        label: 'Data One',
        backgroundColor: this.gradient,
        data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bubble"].extend({
  mounted: function mounted() {
    this.renderChart({
      datasets: [{
        label: 'Data One',
        backgroundColor: 'rgba(255,99,132,1)',
        data: [{
          x: 20,
          y: 25,
          r: 5
        }, {
          x: 40,
          y: 10,
          r: 10
        }, {
          x: 30,
          y: 22,
          r: 30
        }]
      }, {
        label: 'Data Two',
        backgroundColor: 'rgba(0, 216, 255, .3)',
        data: [{
          x: 10,
          y: 30,
          r: 15
        }, {
          x: 20,
          y: 20,
          r: 10
        }, {
          x: 15,
          y: 8,
          r: 30
        }]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Doughnut"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
      datasets: [{
        backgroundColor: ['rgba(65, 184, 131, .8)', 'rgba(228, 102, 81, .8)', 'rgba(0, 216, 255, .8)', 'rgba(155, 89, 182, .8)'],
        borderWidth: 0,
        data: [40, 20, 80, 10]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  data: function data() {
    return {
      gradient: null,
      gradient2: null
    };
  },
  mounted: function mounted() {
    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);

    this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)');
    this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
    this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)');

    this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)');
    this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
    this.gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');

    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [{
        label: 'Data One',
        borderColor: '#FC2525',
        pointBackgroundColor: 'white',
        borderWidth: 1,
        pointBorderColor: 'white',
        backgroundColor: this.gradient,
        data: [40, 39, 10, 40, 39, 80, 40]
      }, {
        label: 'Data Two',
        borderColor: '#05CBE1',
        pointBackgroundColor: 'white',
        pointBorderColor: 'white',
        borderWidth: 1,
        backgroundColor: this.gradient2,
        data: [60, 55, 32, 10, 2, 12, 53]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
      datasets: [{
        backgroundColor: ['rgba(65, 184, 131, .8)', 'rgba(228, 102, 81, .8)', 'rgba(0, 216, 255, .8)', 'rgba(155, 89, 182, .8)'],
        borderWidth: 0,
        data: [40, 20, 80, 10]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["PolarArea"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['Eating', 'Drinking'],
      datasets: [{
        label: 'My First dataset',
        backgroundColor: 'rgba(0, 216, 255, .3)',
        borderColor: 'rgba(0, 216, 255, .8)',
        borderWidth: 1,
        pointBackgroundColor: '#fff',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(179,181,198,1)',
        data: [65, 59, 90, 81, 56, 55, 40]
      }, {
        label: 'My Second dataset',
        backgroundColor: 'rgba(228, 102, 81, .3)',
        borderColor: 'rgba(255,99,132,1)',
        pointBackgroundColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(255,99,132,1)',
        data: [28, 48, 40, 19, 96, 27, 100]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Radar"].extend({
  mounted: function mounted() {
    this.renderChart({
      labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
      datasets: [{
        label: 'My First dataset',
        backgroundColor: 'rgba(0, 216, 255, .3)',
        borderColor: 'rgba(0, 216, 255, .8)',
        borderWidth: 1,
        pointBackgroundColor: '#fff',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(179,181,198,1)',
        data: [65, 59, 90, 81, 56, 55, 40]
      }, {
        label: 'My Second dataset',
        backgroundColor: 'rgba(228, 102, 81, .3)',
        borderColor: 'rgba(255,99,132,1)',
        pointBackgroundColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(255,99,132,1)',
        data: [28, 48, 40, 19, 96, 27, 100]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveData = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveData;


/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
  mixins: [reactiveData],
  data: function data() {
    return {
      chartData: null,
      gradient: null
    };
  },
  created: function created() {
    this.fillData();
  },
  mounted: function mounted() {
    var _this = this;

    this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
    this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)');
    this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
    this.gradient.addColorStop(1, 'rgba(145, 67, 204, 0.46)');

    this.renderChart(this.chartData, { responsive: true, maintainAspectRatio: false });

    setInterval(function () {
      _this.fillData();
    }, 5000);
  },


  methods: {
    fillData: function fillData() {
      this.chartData = {
        labels: ['January' + this.getRandomInt(), 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [{
          label: 'Data One',
          backgroundColor: this.gradient,
          data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
        }]
      };
    },
    getRandomInt: function getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("🦄 vue-chartjs demo")]), _vm._v(" "), _c('div', {
    staticClass: "Chart__list"
  }, [_c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Linechart")]), _vm._v(" "), _c('line-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Barchart")]), _vm._v(" "), _c('bar-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Barchart with reactive mixing for live data")]), _vm._v(" "), _c('reactive-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Doughnutchart")]), _vm._v(" "), _c('doughnut-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Piechart")]), _vm._v(" "), _c('pie-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Radarchart")]), _vm._v(" "), _c('radar-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Polararea")]), _vm._v(" "), _c('polar-area-example')], 1), _vm._v(" "), _c('div', {
    staticClass: "Chart"
  }, [_c('h2', [_vm._v("Bubblechart")]), _vm._v(" "), _c('bubble-example')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[17]);


// WEBPACK FOOTER //
// static/js/app.5ac61c02939f62ee5c05.js